export const enum actions {
  READ = 'read',
  READ_OTHERS = 'read.others',
  READ_UNASSIGNED = 'read.unassigned',
  READ_BRAIN = 'read.brain',
  WRITE = 'write',
  DELETE = 'delete',
  ASSIGN = 'assign',
  UPDATE = 'update',
  OTHERS = 'others',
}

export type Permissions = { permissions: Permission[] };

export type Permission = { resource_id: string; permission: string; allow: boolean };

export type PermissionsState = { permissions: Permission[]; isUserOwner: boolean };

export type Module =
  | 'accounts'
  | 'analytics'
  | 'audit_logs'
  | 'billing'
  | 'brains'
  | 'broadcasts'
  | 'bundles'
  | 'business_hours'
  | 'campaigns'
  | 'collections'
  | 'contact_field_definitions'
  | 'contacts'
  | 'conversations'
  | 'credentials'
  | 'datasources'
  | 'debts'
  | 'departments'
  | 'desk_webhooks'
  | 'desks'
  | 'dialogs'
  | 'documents'
  | 'entities'
  | 'filters'
  | 'integrations'
  | 'intents'
  | 'invitations'
  | 'language_models'
  | 'logs'
  | 'macros'
  | 'model_strategy'
  | 'plugins'
  | 'reports'
  | 'roles'
  | 'rules'
  | 'sessions'
  | 'speech_models'
  | 'speech_strategy'
  | 'teams'
  | 'versions'
  | 'views'
  | 'webhooks'
  | 'conversations.read.departments';
